import React, { HTMLAttributes } from 'react';
import classNames from 'classnames';

import styles from './BubbleCount.module.scss';

type PropsType = HTMLAttributes<HTMLSpanElement> & { count: number };

export default function BubbleCount({
  count,
  className,
}: PropsType): JSX.Element {
  return <span className={classNames(styles.bubble, className)}>{count}</span>;
}
